module.exports = __webpack_public_path__ + "img/plan_copy.14886321.svg";